import { UiEvent } from './utils/ui-event';
import { Logger } from './tracking/logger';

const trackViewEvent = () => {
	new Logger();
	UiEvent.trackUIEvent('', '', 'view');
};

if (/complete|interactive|loaded/.test(document.readyState)) {
	trackViewEvent();
} else {
	document.addEventListener('DOMContentLoaded', trackViewEvent);
}
